"use strict";

require("core-js/modules/es.object.from-entries.js");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultThemeStyles = exports.test = exports.createStyles = void 0;

var react_1 = require("@emotion/react");

var components_utils_1 = require("@conte-ltd/components-utils");

function createStyles(styles, variables) {
  var entries = Object.entries(styles).map(function (_a) {
    var _b = __read(_a, 2),
        key = _b[0],
        value = _b[1];

    var themeKey = value.themeKey,
        properties = value.properties,
        propStyles = value.styles,
        other = __rest(value, ["themeKey", "properties", "styles"]);

    var styles = typeof propStyles === 'function' ? propStyles(variables) : propStyles;

    if ((0, components_utils_1.isNotEmpty)(other)) {
      return [key, createStyles(other, variables)];
    }

    if (typeof themeKey === 'string' && Array.isArray(properties)) {
      var theme = variables[themeKey];

      if (typeof theme === 'object') {
        return [key, (0, components_utils_1.transformNestedObjectValues)(theme, function (_a) {
          var _b = __read(_a, 2),
              value = _b[1];

          var entries = properties.map(function (property) {
            return [property, value];
          });
          return (0, react_1.css)([styles, Object.fromEntries(entries)]);
        })];
      } else {
        var entries_1 = properties.map(function (property) {
          return [property, value];
        });
        return [key, (0, react_1.css)([styles, Object.fromEntries(entries_1)])];
      }
    }

    return [key, styles];
  });
  return Object.fromEntries(entries);
}

exports.createStyles = createStyles;

function test(styles) {
  styles.flex;
}

exports.test = test;
exports.defaultThemeStyles = {
  position: {
    static: {
      styles: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: static;\n      "], ["\n        position: static;\n      "])))
    },
    relative: {
      styles: (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        position: relative;\n      "], ["\n        position: relative;\n      "])))
    },
    absolute: {
      styles: (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        position: absolute;\n      "], ["\n        position: absolute;\n      "])))
    },
    fixed: {
      styles: (0, react_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        position: fixed;\n      "], ["\n        position: fixed;\n      "])))
    },
    sticky: {
      styles: (0, react_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        position: sticky;\n      "], ["\n        position: sticky;\n      "])))
    }
  },
  display: {
    none: {
      styles: (0, react_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        display: none;\n      "], ["\n        display: none;\n      "])))
    },
    contents: {
      styles: (0, react_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        display: contents;\n      "], ["\n        display: contents;\n      "])))
    },
    block: {
      styles: (0, react_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        display: block;\n      "], ["\n        display: block;\n      "])))
    },
    flex: {
      styles: (0, react_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        display: flex;\n      "], ["\n        display: flex;\n      "])))
    },
    grid: {
      styles: (0, react_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n        display: grid;\n      "], ["\n        display: grid;\n      "])))
    },
    flowRoot: {
      styles: (0, react_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n        display: flow-root;\n      "], ["\n        display: flow-root;\n      "])))
    },
    inline: {
      styles: (0, react_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n        display: inline;\n      "], ["\n        display: inline;\n      "])))
    },
    inlineBlock: {
      styles: (0, react_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n        display: inline-block;\n      "], ["\n        display: inline-block;\n      "])))
    },
    inlineFlex: {
      styles: (0, react_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n        display: inline-flex;\n      "], ["\n        display: inline-flex;\n      "])))
    },
    inlineGrid: {
      styles: (0, react_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n        display: inline-grid;\n      "], ["\n        display: inline-grid;\n      "])))
    }
  },
  float: {
    none: {
      styles: (0, react_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n        float: none;\n      "], ["\n        float: none;\n      "])))
    },
    left: {
      styles: (0, react_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n        float: left;\n      "], ["\n        float: left;\n      "])))
    },
    right: {
      styles: (0, react_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n        float: right;\n      "], ["\n        float: right;\n      "])))
    }
  },
  overflow: {
    visible: {
      styles: (0, react_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n        overflow: visible;\n      "], ["\n        overflow: visible;\n      "])))
    },
    hidden: {
      styles: (0, react_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n        overflow: hidden;\n      "], ["\n        overflow: hidden;\n      "])))
    },
    scroll: {
      styles: (0, react_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n        overflow: scroll;\n      "], ["\n        overflow: scroll;\n      "])))
    },
    auto: {
      styles: (0, react_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n        overflow: auto;\n      "], ["\n        overflow: auto;\n      "])))
    }
  },
  overscroll: {
    none: {
      styles: (0, react_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n        overscroll-behavior: none;\n      "], ["\n        overscroll-behavior: none;\n      "])))
    },
    auto: {
      styles: (0, react_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n        overscroll-behavior: auto;\n      "], ["\n        overscroll-behavior: auto;\n      "])))
    },
    contain: {
      styles: (0, react_1.css)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n        overscroll-behavior: contain;\n      "], ["\n        overscroll-behavior: contain;\n      "])))
    }
  },
  scroll: {
    auto: {
      styles: (0, react_1.css)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n        scroll-behavior: auto;\n      "], ["\n        scroll-behavior: auto;\n      "])))
    },
    smooth: {
      styles: (0, react_1.css)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n        scroll-behavior: smooth;\n      "], ["\n        scroll-behavior: smooth;\n      "])))
    }
  },
  flexDirection: {
    row: {
      styles: (0, react_1.css)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n        flex-direction: row;\n      "], ["\n        flex-direction: row;\n      "])))
    },
    rowReverse: {
      styles: (0, react_1.css)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n        flex-direction: row-reverse;\n      "], ["\n        flex-direction: row-reverse;\n      "])))
    },
    column: {
      styles: (0, react_1.css)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n        flex-direction: column;\n      "], ["\n        flex-direction: column;\n      "])))
    },
    columnReverse: {
      styles: (0, react_1.css)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n        flex-direction: column-reverse;\n      "], ["\n        flex-direction: column-reverse;\n      "])))
    }
  },
  flexWrap: {
    wrap: {
      styles: (0, react_1.css)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n        flex-wrap: wrap;\n      "], ["\n        flex-wrap: wrap;\n      "])))
    },
    nowrap: {
      styles: (0, react_1.css)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n        flex-wrap: nowrap;\n      "], ["\n        flex-wrap: nowrap;\n      "])))
    },
    wrapReverse: {
      styles: (0, react_1.css)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n        flex-wrap: wrap-reverse;\n      "], ["\n        flex-wrap: wrap-reverse;\n      "])))
    }
  },
  justifyContent: {
    center: {
      styles: (0, react_1.css)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n        justify-content: center;\n      "], ["\n        justify-content: center;\n      "])))
    },
    start: {
      styles: (0, react_1.css)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n        justify-content: start;\n      "], ["\n        justify-content: start;\n      "])))
    },
    end: {
      styles: (0, react_1.css)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n        justify-content: end;\n      "], ["\n        justify-content: end;\n      "])))
    },
    flexStart: {
      styles: (0, react_1.css)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n        justify-content: flex-start;\n      "], ["\n        justify-content: flex-start;\n      "])))
    },
    flexEnd: {
      styles: (0, react_1.css)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n        justify-content: flex-end;\n      "], ["\n        justify-content: flex-end;\n      "])))
    },
    spaceAround: {
      styles: (0, react_1.css)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n        justify-content: space-around;\n      "], ["\n        justify-content: space-around;\n      "])))
    },
    spaceBetween: {
      styles: (0, react_1.css)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n        justify-content: space-between;\n      "], ["\n        justify-content: space-between;\n      "])))
    },
    spaceEvenly: {
      styles: (0, react_1.css)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n        justify-content: space-evenly;\n      "], ["\n        justify-content: space-evenly;\n      "])))
    },
    stretch: {
      styles: (0, react_1.css)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n        justify-content: stretch;\n      "], ["\n        justify-content: stretch;\n      "])))
    }
  },
  justifyItems: {
    center: {
      styles: (0, react_1.css)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n        justify-items: center;\n      "], ["\n        justify-items: center;\n      "])))
    },
    start: {
      styles: (0, react_1.css)(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n        justify-items: start;\n      "], ["\n        justify-items: start;\n      "])))
    },
    end: {
      styles: (0, react_1.css)(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n        justify-items: end;\n      "], ["\n        justify-items: end;\n      "])))
    },
    stretch: {
      styles: (0, react_1.css)(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n        justify-items: stretch;\n      "], ["\n        justify-items: stretch;\n      "])))
    }
  },
  alignContent: {
    center: {
      styles: (0, react_1.css)(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n        align-content: center;\n      "], ["\n        align-content: center;\n      "])))
    },
    start: {
      styles: (0, react_1.css)(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n        align-content: start;\n      "], ["\n        align-content: start;\n      "])))
    },
    end: {
      styles: (0, react_1.css)(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n        align-content: end;\n      "], ["\n        align-content: end;\n      "])))
    },
    flexStart: {
      styles: (0, react_1.css)(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n        align-content: flex-start;\n      "], ["\n        align-content: flex-start;\n      "])))
    },
    flexEnd: {
      styles: (0, react_1.css)(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n        align-content: flex-end;\n      "], ["\n        align-content: flex-end;\n      "])))
    },
    spaceAround: {
      styles: (0, react_1.css)(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n        align-content: space-around;\n      "], ["\n        align-content: space-around;\n      "])))
    },
    spaceBetween: {
      styles: (0, react_1.css)(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n        align-content: space-between;\n      "], ["\n        align-content: space-between;\n      "])))
    },
    spaceEvenly: {
      styles: (0, react_1.css)(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n        align-content: space-evenly;\n      "], ["\n        align-content: space-evenly;\n      "])))
    },
    stretch: {
      styles: (0, react_1.css)(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n        align-content: stretch;\n      "], ["\n        align-content: stretch;\n      "])))
    }
  },
  alignItems: {
    center: {
      styles: (0, react_1.css)(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n        align-items: center;\n      "], ["\n        align-items: center;\n      "])))
    },
    start: {
      styles: (0, react_1.css)(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n        align-items: start;\n      "], ["\n        align-items: start;\n      "])))
    },
    end: {
      styles: (0, react_1.css)(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n        align-items: end;\n      "], ["\n        align-items: end;\n      "])))
    },
    flexStart: {
      styles: (0, react_1.css)(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n        align-items: flex-start;\n      "], ["\n        align-items: flex-start;\n      "])))
    },
    flexEnd: {
      styles: (0, react_1.css)(templateObject_61 || (templateObject_61 = __makeTemplateObject(["\n        align-items: flex-end;\n      "], ["\n        align-items: flex-end;\n      "])))
    },
    stretch: {
      styles: (0, react_1.css)(templateObject_62 || (templateObject_62 = __makeTemplateObject(["\n        align-items: stretch;\n      "], ["\n        align-items: stretch;\n      "])))
    },
    baseline: {
      styles: (0, react_1.css)(templateObject_63 || (templateObject_63 = __makeTemplateObject(["\n        align-items: baseline;\n      "], ["\n        align-items: baseline;\n      "])))
    }
  },
  placeContent: {
    center: {
      styles: (0, react_1.css)(templateObject_64 || (templateObject_64 = __makeTemplateObject(["\n        place-content: center;\n      "], ["\n        place-content: center;\n      "])))
    },
    start: {
      styles: (0, react_1.css)(templateObject_65 || (templateObject_65 = __makeTemplateObject(["\n        place-content: start;\n      "], ["\n        place-content: start;\n      "])))
    },
    end: {
      styles: (0, react_1.css)(templateObject_66 || (templateObject_66 = __makeTemplateObject(["\n        place-content: end;\n      "], ["\n        place-content: end;\n      "])))
    },
    spaceAround: {
      styles: (0, react_1.css)(templateObject_67 || (templateObject_67 = __makeTemplateObject(["\n        place-content: space-around;\n      "], ["\n        place-content: space-around;\n      "])))
    },
    spaceBetween: {
      styles: (0, react_1.css)(templateObject_68 || (templateObject_68 = __makeTemplateObject(["\n        place-content: space-between;\n      "], ["\n        place-content: space-between;\n      "])))
    },
    spaceEvenly: {
      styles: (0, react_1.css)(templateObject_69 || (templateObject_69 = __makeTemplateObject(["\n        place-content: space-evenly;\n      "], ["\n        place-content: space-evenly;\n      "])))
    },
    stretch: {
      styles: (0, react_1.css)(templateObject_70 || (templateObject_70 = __makeTemplateObject(["\n        align-content: stretch;\n      "], ["\n        align-content: stretch;\n      "])))
    }
  },
  placeItems: {
    center: {
      styles: (0, react_1.css)(templateObject_71 || (templateObject_71 = __makeTemplateObject(["\n        place-items: center;\n      "], ["\n        place-items: center;\n      "])))
    },
    start: {
      styles: (0, react_1.css)(templateObject_72 || (templateObject_72 = __makeTemplateObject(["\n        place-items: start;\n      "], ["\n        place-items: start;\n      "])))
    },
    end: {
      styles: (0, react_1.css)(templateObject_73 || (templateObject_73 = __makeTemplateObject(["\n        place-items: end;\n      "], ["\n        place-items: end;\n      "])))
    },
    stretch: {
      styles: (0, react_1.css)(templateObject_74 || (templateObject_74 = __makeTemplateObject(["\n        place-items: stretch;\n      "], ["\n        place-items: stretch;\n      "])))
    }
  },
  justifySelf: {
    center: {
      styles: (0, react_1.css)(templateObject_75 || (templateObject_75 = __makeTemplateObject(["\n        justify-self: center;\n      "], ["\n        justify-self: center;\n      "])))
    },
    start: {
      styles: (0, react_1.css)(templateObject_76 || (templateObject_76 = __makeTemplateObject(["\n        justify-self: start;\n      "], ["\n        justify-self: start;\n      "])))
    },
    end: {
      styles: (0, react_1.css)(templateObject_77 || (templateObject_77 = __makeTemplateObject(["\n        justify-self: end;\n      "], ["\n        justify-self: end;\n      "])))
    },
    stretch: {
      styles: (0, react_1.css)(templateObject_78 || (templateObject_78 = __makeTemplateObject(["\n        justify-self: stretch;\n      "], ["\n        justify-self: stretch;\n      "])))
    }
  },
  alignSelf: {
    center: {
      styles: (0, react_1.css)(templateObject_79 || (templateObject_79 = __makeTemplateObject(["\n        align-self: center;\n      "], ["\n        align-self: center;\n      "])))
    },
    start: {
      styles: (0, react_1.css)(templateObject_80 || (templateObject_80 = __makeTemplateObject(["\n        align-self: start;\n      "], ["\n        align-self: start;\n      "])))
    },
    end: {
      styles: (0, react_1.css)(templateObject_81 || (templateObject_81 = __makeTemplateObject(["\n        align-self: end;\n      "], ["\n        align-self: end;\n      "])))
    },
    flexStart: {
      styles: (0, react_1.css)(templateObject_82 || (templateObject_82 = __makeTemplateObject(["\n        align-self: flex-start;\n      "], ["\n        align-self: flex-start;\n      "])))
    },
    flexEnd: {
      styles: (0, react_1.css)(templateObject_83 || (templateObject_83 = __makeTemplateObject(["\n        align-self: flex-end;\n      "], ["\n        align-self: flex-end;\n      "])))
    },
    stretch: {
      styles: (0, react_1.css)(templateObject_84 || (templateObject_84 = __makeTemplateObject(["\n        align-self: stretch;\n      "], ["\n        align-self: stretch;\n      "])))
    },
    baseline: {
      styles: (0, react_1.css)(templateObject_85 || (templateObject_85 = __makeTemplateObject(["\n        align-self: baseline;\n      "], ["\n        align-self: baseline;\n      "])))
    }
  },
  placeSelf: {
    center: {
      styles: (0, react_1.css)(templateObject_86 || (templateObject_86 = __makeTemplateObject(["\n        place-self: center;\n      "], ["\n        place-self: center;\n      "])))
    },
    start: {
      styles: (0, react_1.css)(templateObject_87 || (templateObject_87 = __makeTemplateObject(["\n        place-self: start;\n      "], ["\n        place-self: start;\n      "])))
    },
    end: {
      styles: (0, react_1.css)(templateObject_88 || (templateObject_88 = __makeTemplateObject(["\n        place-self: end;\n      "], ["\n        place-self: end;\n      "])))
    },
    stretch: {
      styles: (0, react_1.css)(templateObject_89 || (templateObject_89 = __makeTemplateObject(["\n        place-self: stretch;\n      "], ["\n        place-self: stretch;\n      "])))
    }
  },
  gap: {
    all: {
      themeKey: 'spacing',
      properties: ['gap']
    },
    row: {
      themeKey: 'spacing',
      properties: ['rowGap']
    },
    column: {
      themeKey: 'spacing',
      properties: ['columnGap']
    }
  },
  flex: {
    grow: {
      themeKey: 'flex',
      properties: ['flexGrow']
    },
    shrink: {
      themeKey: 'flex',
      properties: ['flexShrink']
    },
    basis: {
      themeKey: 'size',
      properties: ['flexBasis']
    }
  },
  order: {
    themeKey: 'order',
    properties: ['order']
  },
  gridTemplate: {
    rows: {
      themeKey: 'gridTemplate',
      properties: ['gridTemplateRows']
    },
    columns: {
      themeKey: 'gridTemplate',
      properties: ['gridTemplateColumns']
    }
  },
  gridFlow: {
    row: {
      styles: (0, react_1.css)(templateObject_90 || (templateObject_90 = __makeTemplateObject(["\n        grid-auto-flow: row;\n      "], ["\n        grid-auto-flow: row;\n      "])))
    },
    column: {
      styles: (0, react_1.css)(templateObject_91 || (templateObject_91 = __makeTemplateObject(["\n        grid-auto-flow: column;\n      "], ["\n        grid-auto-flow: column;\n      "])))
    },
    dense: {
      styles: (0, react_1.css)(templateObject_92 || (templateObject_92 = __makeTemplateObject(["\n        grid-auto-flow: dense;\n      "], ["\n        grid-auto-flow: dense;\n      "])))
    }
  },
  grid: {
    row: {
      span: {
        themeKey: 'gridSpan',
        properties: ['gridRow']
      },
      start: {
        themeKey: 'grid',
        properties: ['gridRowStart']
      },
      end: {
        themeKey: 'grid',
        properties: ['gridRowEnd']
      }
    },
    column: {
      span: {
        themeKey: 'gridSpan',
        properties: ['gridColumn']
      },
      start: {
        themeKey: 'grid',
        properties: ['gridColumnStart']
      },
      end: {
        themeKey: 'grid',
        properties: ['gridColumnEnd']
      }
    }
  },
  color: {
    themeKey: 'color',
    properties: ['color']
  },
  bgColor: {
    themeKey: 'color',
    properties: ['backgroundColor']
  },
  borderColor: {
    themeKey: 'color',
    properties: ['borderColor']
  },
  top: {
    themeKey: 'spacing',
    properties: ['top']
  },
  left: {
    themeKey: 'spacing',
    properties: ['left']
  },
  right: {
    themeKey: 'spacing',
    properties: ['right']
  },
  bottom: {
    themeKey: 'spacing',
    properties: ['bottom']
  },
  margin: {
    all: {
      themeKey: 'spacing',
      properties: ['margin']
    },
    top: {
      themeKey: 'spacing',
      properties: ['marginTop']
    },
    bottom: {
      themeKey: 'spacing',
      properties: ['marginBottom']
    },
    left: {
      themeKey: 'spacing',
      properties: ['marginLeft']
    },
    right: {
      themeKey: 'spacing',
      properties: ['marginRight']
    },
    x: {
      themeKey: 'spacing',
      properties: ['marginLeft', 'marginRight']
    },
    y: {
      themeKey: 'spacing',
      properties: ['marginTop', 'marginBottom']
    }
  },
  padding: {
    all: {
      themeKey: 'spacing',
      properties: ['padding']
    },
    top: {
      themeKey: 'spacing',
      properties: ['paddingTop']
    },
    bottom: {
      themeKey: 'spacing',
      properties: ['paddingBottom']
    },
    left: {
      themeKey: 'spacing',
      properties: ['paddingLeft']
    },
    right: {
      themeKey: 'spacing',
      properties: ['paddingRight']
    },
    x: {
      themeKey: 'spacing',
      properties: ['paddingLeft', 'paddingRight']
    },
    y: {
      themeKey: 'spacing',
      properties: ['paddingTop', 'paddingBottom']
    }
  },
  width: {
    themeKey: 'size',
    properties: ['width']
  },
  maxWidth: {
    themeKey: 'size',
    properties: ['maxWidth']
  },
  minWidth: {
    themeKey: 'size',
    properties: ['minWidth']
  },
  height: {
    themeKey: 'size',
    properties: ['height']
  },
  maxHeight: {
    themeKey: 'size',
    properties: ['maxHeight']
  },
  minHeight: {
    themeKey: 'size',
    properties: ['minHeight']
  },
  size: {
    themeKey: 'size',
    properties: ['width', 'height']
  },
  fontFamily: {
    themeKey: 'fontFamily',
    properties: ['fontFamily']
  },
  fontStyle: {
    normal: {
      styles: (0, react_1.css)(templateObject_93 || (templateObject_93 = __makeTemplateObject(["\n        font-style: normal;\n      "], ["\n        font-style: normal;\n      "])))
    },
    italic: {
      styles: (0, react_1.css)(templateObject_94 || (templateObject_94 = __makeTemplateObject(["\n        font-style: italic;\n      "], ["\n        font-style: italic;\n      "])))
    }
  },
  fontSize: {
    themeKey: 'fontSize',
    properties: ['fontSize']
  },
  fontWeight: {
    themeKey: 'fontWeight',
    properties: ['fontWeight']
  },
  letterSpacing: {
    themeKey: 'letterSpacing',
    properties: ['letterSpacing']
  },
  lineHeight: {
    themeKey: 'lineHeight',
    properties: ['lineHeight']
  },
  textAlign: {
    left: {
      styles: (0, react_1.css)(templateObject_95 || (templateObject_95 = __makeTemplateObject(["\n        text-align: left;\n      "], ["\n        text-align: left;\n      "])))
    },
    right: {
      styles: (0, react_1.css)(templateObject_96 || (templateObject_96 = __makeTemplateObject(["\n        text-align: right;\n      "], ["\n        text-align: right;\n      "])))
    },
    center: {
      styles: (0, react_1.css)(templateObject_97 || (templateObject_97 = __makeTemplateObject(["\n        text-align: center;\n      "], ["\n        text-align: center;\n      "])))
    },
    justify: {
      styles: (0, react_1.css)(templateObject_98 || (templateObject_98 = __makeTemplateObject(["\n        text-align: justify;\n      "], ["\n        text-align: justify;\n      "])))
    }
  },
  textTransform: {
    none: {
      styles: (0, react_1.css)(templateObject_99 || (templateObject_99 = __makeTemplateObject(["\n        text-transform: none;\n      "], ["\n        text-transform: none;\n      "])))
    },
    capitalize: {
      styles: (0, react_1.css)(templateObject_100 || (templateObject_100 = __makeTemplateObject(["\n        text-transform: capitalize;\n      "], ["\n        text-transform: capitalize;\n      "])))
    },
    uppercase: {
      styles: (0, react_1.css)(templateObject_101 || (templateObject_101 = __makeTemplateObject(["\n        text-transform: uppercase;\n      "], ["\n        text-transform: uppercase;\n      "])))
    },
    lowercase: {
      styles: (0, react_1.css)(templateObject_102 || (templateObject_102 = __makeTemplateObject(["\n        text-transform: lowercase;\n      "], ["\n        text-transform: lowercase;\n      "])))
    }
  },
  textDecoration: {
    none: {
      styles: (0, react_1.css)(templateObject_103 || (templateObject_103 = __makeTemplateObject(["\n        text-decoration: none;\n      "], ["\n        text-decoration: none;\n      "])))
    },
    under: {
      styles: (0, react_1.css)(templateObject_104 || (templateObject_104 = __makeTemplateObject(["\n        text-decoration: underline;\n      "], ["\n        text-decoration: underline;\n      "])))
    },
    over: {
      styles: (0, react_1.css)(templateObject_105 || (templateObject_105 = __makeTemplateObject(["\n        text-decoration: overline;\n      "], ["\n        text-decoration: overline;\n      "])))
    },
    through: {
      styles: (0, react_1.css)(templateObject_106 || (templateObject_106 = __makeTemplateObject(["\n        text-decoration: line-through;\n      "], ["\n        text-decoration: line-through;\n      "])))
    }
  },
  whiteSpace: {
    normal: {
      styles: (0, react_1.css)(templateObject_107 || (templateObject_107 = __makeTemplateObject(["\n        white-space: normal;\n      "], ["\n        white-space: normal;\n      "])))
    },
    nowrap: {
      styles: (0, react_1.css)(templateObject_108 || (templateObject_108 = __makeTemplateObject(["\n        white-space: nowrap;\n      "], ["\n        white-space: nowrap;\n      "])))
    },
    pre: {
      styles: (0, react_1.css)(templateObject_109 || (templateObject_109 = __makeTemplateObject(["\n        white-space: pre;\n      "], ["\n        white-space: pre;\n      "])))
    },
    preLine: {
      styles: (0, react_1.css)(templateObject_110 || (templateObject_110 = __makeTemplateObject(["\n        white-space: pre-line;\n      "], ["\n        white-space: pre-line;\n      "])))
    },
    preWrap: {
      styles: (0, react_1.css)(templateObject_111 || (templateObject_111 = __makeTemplateObject(["\n        white-space: pre-wrap;\n      "], ["\n        white-space: pre-wrap;\n      "])))
    }
  },
  border: {
    all: {
      themeKey: 'border',
      properties: ['border']
    },
    top: {
      themeKey: 'border',
      properties: ['borderTop']
    },
    left: {
      themeKey: 'border',
      properties: ['borderLeft']
    },
    right: {
      themeKey: 'border',
      properties: ['borderRight']
    },
    bottom: {
      themeKey: 'border',
      properties: ['borderBottom']
    }
  },
  borderRadius: {
    all: {
      themeKey: 'radius',
      properties: ['borderRadius']
    },
    topLeft: {
      themeKey: 'radius',
      properties: ['borderTopLeftRadius']
    },
    topRight: {
      themeKey: 'radius',
      properties: ['borderTopRightRadius']
    },
    bottomLeft: {
      themeKey: 'radius',
      properties: ['borderBottomLeftRadius']
    },
    bottomRight: {
      themeKey: 'radius',
      properties: ['borderBottomRightRadius']
    }
  },
  zIndex: {
    themeKey: 'zIndex',
    properties: ['zIndex']
  },
  boxShadow: {
    themeKey: 'shadow',
    properties: ['boxShadow']
  },
  textShadow: {
    themeKey: 'shadow',
    properties: ['boxShadow']
  },
  opacity: {
    themeKey: 'opacity',
    properties: ['opacity']
  },
  transition: {
    property: {
      themeKey: 'transition',
      properties: ['transitionProperty']
    },
    duration: {
      themeKey: 'transitionTime',
      properties: ['transitionDuration']
    },
    delay: {
      themeKey: 'transitionTime',
      properties: ['transitionDelay']
    },
    easing: {
      themeKey: 'transitionEasing',
      properties: ['transitionTimingFunction']
    }
  },
  cursor: {
    default: {
      styles: (0, react_1.css)(templateObject_112 || (templateObject_112 = __makeTemplateObject(["\n        cursor: default;\n      "], ["\n        cursor: default;\n      "])))
    },
    pointer: {
      styles: (0, react_1.css)(templateObject_113 || (templateObject_113 = __makeTemplateObject(["\n        cursor: auto;\n      "], ["\n        cursor: auto;\n      "])))
    },
    help: {
      styles: (0, react_1.css)(templateObject_114 || (templateObject_114 = __makeTemplateObject(["\n        cursor: help;\n      "], ["\n        cursor: help;\n      "])))
    },
    wait: {
      styles: (0, react_1.css)(templateObject_115 || (templateObject_115 = __makeTemplateObject(["\n        cursor: wait;\n      "], ["\n        cursor: wait;\n      "])))
    },
    move: {
      styles: (0, react_1.css)(templateObject_116 || (templateObject_116 = __makeTemplateObject(["\n        cursor: move;\n      "], ["\n        cursor: move;\n      "])))
    },
    notAllowed: {
      styles: (0, react_1.css)(templateObject_117 || (templateObject_117 = __makeTemplateObject(["\n        cursor: not-allowed;\n      "], ["\n        cursor: not-allowed;\n      "])))
    },
    text: {
      styles: (0, react_1.css)(templateObject_118 || (templateObject_118 = __makeTemplateObject(["\n        cursor: text;\n      "], ["\n        cursor: text;\n      "])))
    }
  },
  pointerEvents: {
    none: {
      styles: (0, react_1.css)(templateObject_119 || (templateObject_119 = __makeTemplateObject(["\n        pointer-events: none;\n      "], ["\n        pointer-events: none;\n      "])))
    },
    auto: {
      styles: (0, react_1.css)(templateObject_120 || (templateObject_120 = __makeTemplateObject(["\n        pointer-events: auto;\n      "], ["\n        pointer-events: auto;\n      "])))
    }
  },
  outline: {
    none: {
      styles: (0, react_1.css)(templateObject_121 || (templateObject_121 = __makeTemplateObject(["\n        outline: 2px solid transparent;\n        outline-offset: 2px;\n      "], ["\n        outline: 2px solid transparent;\n        outline-offset: 2px;\n      "])))
    }
  },
  visibility: {
    visible: {
      styles: (0, react_1.css)(templateObject_122 || (templateObject_122 = __makeTemplateObject(["\n        visibility: visible;\n      "], ["\n        visibility: visible;\n      "])))
    },
    hidden: {
      styles: (0, react_1.css)(templateObject_123 || (templateObject_123 = __makeTemplateObject(["\n        visibility: hidden;\n      "], ["\n        visibility: hidden;\n      "])))
    }
  },
  boxSizing: {
    border: {
      styles: (0, react_1.css)(templateObject_124 || (templateObject_124 = __makeTemplateObject(["\n        box-sizing: border-box;\n      "], ["\n        box-sizing: border-box;\n      "])))
    },
    content: {
      styles: (0, react_1.css)(templateObject_125 || (templateObject_125 = __makeTemplateObject(["\n        box-sizing: content-box;\n      "], ["\n        box-sizing: content-box;\n      "])))
    }
  },
  objectFit: {
    none: {
      styles: (0, react_1.css)(templateObject_126 || (templateObject_126 = __makeTemplateObject(["\n        object-fit: none;\n      "], ["\n        object-fit: none;\n      "])))
    },
    contain: {
      styles: (0, react_1.css)(templateObject_127 || (templateObject_127 = __makeTemplateObject(["\n        object-fit: contain;\n      "], ["\n        object-fit: contain;\n      "])))
    },
    cover: {
      styles: (0, react_1.css)(templateObject_128 || (templateObject_128 = __makeTemplateObject(["\n        object-fit: cover;\n      "], ["\n        object-fit: cover;\n      "])))
    },
    fill: {
      styles: (0, react_1.css)(templateObject_129 || (templateObject_129 = __makeTemplateObject(["\n        object-fit: fill;\n      "], ["\n        object-fit: fill;\n      "])))
    },
    scaleDown: {
      styles: (0, react_1.css)(templateObject_130 || (templateObject_130 = __makeTemplateObject(["\n        object-fit: scale-down;\n      "], ["\n        object-fit: scale-down;\n      "])))
    }
  },
  objectPosition: {
    center: {
      styles: (0, react_1.css)(templateObject_131 || (templateObject_131 = __makeTemplateObject(["\n        object-position: center;\n      "], ["\n        object-position: center;\n      "])))
    },
    top: {
      styles: (0, react_1.css)(templateObject_132 || (templateObject_132 = __makeTemplateObject(["\n        object-position: top;\n      "], ["\n        object-position: top;\n      "])))
    },
    left: {
      styles: (0, react_1.css)(templateObject_133 || (templateObject_133 = __makeTemplateObject(["\n        object-position: left;\n      "], ["\n        object-position: left;\n      "])))
    },
    right: {
      styles: (0, react_1.css)(templateObject_134 || (templateObject_134 = __makeTemplateObject(["\n        object-position: right;\n      "], ["\n        object-position: right;\n      "])))
    },
    bottom: {
      styles: (0, react_1.css)(templateObject_135 || (templateObject_135 = __makeTemplateObject(["\n        object-position: bottom;\n      "], ["\n        object-position: bottom;\n      "])))
    },
    leftTop: {
      styles: (0, react_1.css)(templateObject_136 || (templateObject_136 = __makeTemplateObject(["\n        object-position: left top;\n      "], ["\n        object-position: left top;\n      "])))
    },
    leftBottom: {
      styles: (0, react_1.css)(templateObject_137 || (templateObject_137 = __makeTemplateObject(["\n        object-position: left bottom;\n      "], ["\n        object-position: left bottom;\n      "])))
    },
    rightTop: {
      styles: (0, react_1.css)(templateObject_138 || (templateObject_138 = __makeTemplateObject(["\n        object-position: right top;\n      "], ["\n        object-position: right top;\n      "])))
    },
    rightBottom: {
      styles: (0, react_1.css)(templateObject_139 || (templateObject_139 = __makeTemplateObject(["\n        object-position: right bottom;\n      "], ["\n        object-position: right bottom;\n      "])))
    }
  },
  resize: {
    none: {
      styles: (0, react_1.css)(templateObject_140 || (templateObject_140 = __makeTemplateObject(["\n        resize: none;\n      "], ["\n        resize: none;\n      "])))
    },
    both: {
      styles: (0, react_1.css)(templateObject_141 || (templateObject_141 = __makeTemplateObject(["\n        resize: both;\n      "], ["\n        resize: both;\n      "])))
    },
    horizontal: {
      styles: (0, react_1.css)(templateObject_142 || (templateObject_142 = __makeTemplateObject(["\n        resize: horizontal;\n      "], ["\n        resize: horizontal;\n      "])))
    },
    vertical: {
      styles: (0, react_1.css)(templateObject_143 || (templateObject_143 = __makeTemplateObject(["\n        resize: vertical;\n      "], ["\n        resize: vertical;\n      "])))
    }
  },
  // Components Style
  stack: {
    row: {
      styles: (0, react_1.css)(templateObject_144 || (templateObject_144 = __makeTemplateObject(["\n        display: flex;\n        flex-direction: row;\n      "], ["\n        display: flex;\n        flex-direction: row;\n      "])))
    },
    col: {
      styles: (0, react_1.css)(templateObject_145 || (templateObject_145 = __makeTemplateObject(["\n        display: flex;\n        flex-direction: column;\n      "], ["\n        display: flex;\n        flex-direction: column;\n      "])))
    },
    center: {
      row: {
        styles: (0, react_1.css)(templateObject_146 || (templateObject_146 = __makeTemplateObject(["\n          display: flex;\n          flex-direction: row;\n          justify-content: center;\n          align-items: center;\n        "], ["\n          display: flex;\n          flex-direction: row;\n          justify-content: center;\n          align-items: center;\n        "])))
      },
      col: {
        styles: (0, react_1.css)(templateObject_147 || (templateObject_147 = __makeTemplateObject(["\n          display: flex;\n          flex-direction: row;\n          justify-content: center;\n          align-items: center;\n        "], ["\n          display: flex;\n          flex-direction: row;\n          justify-content: center;\n          align-items: center;\n        "])))
      }
    }
  },
  button: {
    solid: {
      themeKey: 'color',
      properties: ['backgroundColor'],
      styles: function styles(theme) {
        return (0, react_1.css)(templateObject_148 || (templateObject_148 = __makeTemplateObject(["\n        color: ", ";\n      "], ["\n        color: ", ";\n      "])), theme.color.white);
      }
    },
    outline: {
      themeKey: 'color',
      properties: ['borderColor'],
      styles: function styles(theme) {
        return (0, react_1.css)(templateObject_149 || (templateObject_149 = __makeTemplateObject(["\n        border: ", ";\n      "], ["\n        border: ", ";\n      "])), theme.border.light);
      }
    },
    text: {
      themeKey: 'color',
      properties: ['color']
    }
  }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66, templateObject_67, templateObject_68, templateObject_69, templateObject_70, templateObject_71, templateObject_72, templateObject_73, templateObject_74, templateObject_75, templateObject_76, templateObject_77, templateObject_78, templateObject_79, templateObject_80, templateObject_81, templateObject_82, templateObject_83, templateObject_84, templateObject_85, templateObject_86, templateObject_87, templateObject_88, templateObject_89, templateObject_90, templateObject_91, templateObject_92, templateObject_93, templateObject_94, templateObject_95, templateObject_96, templateObject_97, templateObject_98, templateObject_99, templateObject_100, templateObject_101, templateObject_102, templateObject_103, templateObject_104, templateObject_105, templateObject_106, templateObject_107, templateObject_108, templateObject_109, templateObject_110, templateObject_111, templateObject_112, templateObject_113, templateObject_114, templateObject_115, templateObject_116, templateObject_117, templateObject_118, templateObject_119, templateObject_120, templateObject_121, templateObject_122, templateObject_123, templateObject_124, templateObject_125, templateObject_126, templateObject_127, templateObject_128, templateObject_129, templateObject_130, templateObject_131, templateObject_132, templateObject_133, templateObject_134, templateObject_135, templateObject_136, templateObject_137, templateObject_138, templateObject_139, templateObject_140, templateObject_141, templateObject_142, templateObject_143, templateObject_144, templateObject_145, templateObject_146, templateObject_147, templateObject_148, templateObject_149;